import {Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import {
    AppToastrService,
    RoutingService,
    ClientsService,
    TravelsService, DictionaryService
} from 'app/services';
import {Travel} from 'app/models';
import {STATE_NAMES} from '../../../common';


@Component({
    selector: 'app-client-travel-history',
    templateUrl: './client-travel-history.html',
    styleUrls: ['./client-travel-history.scss']
})

export class ClientTravelHistoryComponent implements OnInit, OnDestroy {

    @Input() travels: any;
    @Output() notify: EventEmitter<any> = new EventEmitter<any>();
    // travels: Travel[];
    contact: any;
    isLoaded = true;
    filters: any = {};
    total = 0;

    listFilters: any = {
        manager: 'All',
    };
    filtersOld: any;
    allowReset = false;
    defaultFilters = {
        paging: {
            offset: 0,
            limit: 20
        },
        sorting: {
            sortingType: 0,
            propertyName: 'date_from'
        },
    };
    manager: number;
    invoiceTypes = [];

    constructor(private travelsService: TravelsService,
                private dictionaryService: DictionaryService,
                private route: RoutingService,
                private toast: AppToastrService) {
        this.listFilters = JSON.parse(JSON.stringify(this.defaultFilters));
        this.filtersOld = JSON.parse(JSON.stringify(this.listFilters));
    }


    ngOnInit() {
        this.travels.forEach(travel => {
            const fullInvoice = travel.invoices?.filter(invoice => !invoice.is_partial);
            if (fullInvoice) {
                travel.fullInvoice = fullInvoice;
            }
        });
        this.getInvoicesCurrencies();
    }

    ngOnDestroy() {
    }

    openItem(travel: any) {
        travel.isOpened = !travel.isOpened;
    }


    calculateFinalAmount(travel) {
        if (travel.partlyInvoice) {
            const curr = this.setInvoiceCurrency(travel.fullInvoice.length > 0 ? travel.fullInvoice[travel.fullInvoice.length - 1].type : travel?.partlyInvoice[travel?.partlyInvoice.length - 1].type, travel?.currency);
            switch (curr) {
                case 'UAH':
                    return travel.partlyInvoice.cost.uah;
                    break;
                case 'USD':
                    return travel.partlyInvoice.cost.usd;
                    break;
                case 'EUR':
                    return travel.partlyInvoice.cost.eur;
                    break;
            }
        }
        return travel?.cost;
    }

    onFilterChange(key: string) {
        this.allowReset = true;
        if (!this.listFilters[key] || this.listFilters[key] == 'undefined' || this.listFilters[key] === 'All') {
            delete this.listFilters[key];
        }
        if (this.filtersOld[key] !== this.listFilters[key]) {
            this.listFilters.paging.offset = 0;
            this.filtersOld = JSON.parse(JSON.stringify(this.listFilters));
            // this.getTravels();
        }
    }

    getInvoicesCurrencies() {
        this.dictionaryService.getInvoicesTemplate().subscribe(res => {
            if (res) {
                res.forEach(item => item.types.forEach(type => this.invoiceTypes.push(type)));
            }
        }, (err) => {
            this.toast.showToastFromError(err);
        });
    }

    setInvoiceCurrency(invoiceType, travelCurrency) {
        const type = this.invoiceTypes.find(item => item.id === invoiceType);
        return type?.currency ? type?.currency : travelCurrency;
    }

    resetFilters() {
        this.allowReset = false;
        this.listFilters = JSON.parse(JSON.stringify(this.defaultFilters));
        this.filtersOld = JSON.parse(JSON.stringify(this.listFilters));
        this.listFilters.paging.offset = 0;
        // this.getTravels();
    }

    onSorting(type: string) {
        if (this.isLoaded) {
            this.listFilters.paging.offset = 0;
            const sortingType = (this.listFilters.sorting.propertyName === type && !this.listFilters.sorting.sortingType) ? 1 : 0;
            this.listFilters.sorting = {
                sortingType,
                propertyName: type
            };
            this.isLoaded = false;
            // this.getTravels();
        }
    }

    openTravelProfile(e: any, travel: Travel) {
        const name = e.target ? e.target.className : e;
        if (name.indexOf('lnr ') === -1 && name !== 'actions') {
            const clientName = `${travel.dateFrom.format('DD.MM.YYYY')} - ${travel.dateTo.format('DD.MM.YYYY')} ${travel.client.name}`;

            this.route.go(STATE_NAMES.travel, {
                id: travel.id,
                travel: travel,
                clientName: clientName,
                filters: this.filters
            });
        }
    }

    onPageChange(pageNumber: number) {
        this.listFilters.paging.offset = pageNumber * this.listFilters.paging.limit;
        // this.getTravels();
    }

    // private getTravels() {
    //   this.isLoaded = false;
    //   this.travelsService.getTravels(this.listFilters, this.clientId).subscribe((res) => {
    //     if (res) {
    //       this.travels = res.items;
    //       this.total = res.total;
    //       this.isLoaded = true;
    //     }
    //   }, (err) => {
    //     this.travels = [];
    //     this.isLoaded = true;
    //     this.toast.showToastFromError(err);
    //   });
    // }

}
